/* WellHerbs theme interactions */
(function () {
  'use strict';

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* ---------- Money ---------- */
  function formatINR(paise) {
    const rupees = Math.round(paise) / 100;
    const hasFraction = Math.round(rupees * 100) % 100 !== 0;
    return '₹' + rupees.toLocaleString('en-IN', {
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: 2,
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdowns(root) {
    $$('[data-wh-countdown]', root).forEach((el) => {
      if (el.dataset.whReady) return;
      el.dataset.whReady = '1';
      const end = Date.parse(el.dataset.end);
      const wrap = el.closest('[data-wh-offer]');
      if (isNaN(end)) { el.hidden = true; return; }
      const h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el), d = $('[data-d]', el);
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = Math.max(0, end - Date.now());
        if (diff <= 0) {
          if (wrap && wrap.dataset.hideExpired === 'true') wrap.hidden = true;
          else el.hidden = true;
          clearInterval(timer);
          return;
        }
        const days = Math.floor(diff / 86400000);
        const hours = Math.floor(diff / 3600000) - (d ? days * 24 : 0);
        const mins = Math.floor((diff % 3600000) / 60000);
        const secs = Math.floor((diff % 60000) / 1000);
        if (d) d.textContent = pad(days);
        h.textContent = pad(hours);
        m.textContent = pad(mins);
        s.textContent = pad(secs);
      };
      const timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Accordions ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wh-acc-btn]');
    if (!btn) return;
    const item = btn.closest('[data-wh-acc-item]');
    const group = btn.closest('[data-wh-acc]');
    const open = !item.classList.contains('is-open');
    if (group && group.dataset.single === 'true') {
      $$('[data-wh-acc-item].is-open', group).forEach((o) => {
        if (o !== item) { o.classList.remove('is-open'); const b = $('[data-wh-acc-btn]', o); if (b) b.setAttribute('aria-expanded', 'false'); }
      });
    }
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', String(open));
  });

  /* ---------- Review tabs ---------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-wh-tab]');
    if (!tab) return;
    const root = tab.closest('[data-wh-tabs-root]');
    $$('[data-wh-tab]', root).forEach((t) => {
      const active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', String(active));
    });
    const key = tab.dataset.whTab;
    $$('[data-wh-tab-item]', root).forEach((card) => {
      card.hidden = key !== '__all' && card.dataset.whTabItem !== key;
    });
  });

  /* ---------- Gallery ---------- */
  function initGalleries(root) {
    $$('[data-wh-gallery]', root).forEach((g) => {
      if (g.dataset.whReady) return;
      g.dataset.whReady = '1';
      const track = $('[data-wh-track]', g);
      const thumbs = $$('[data-wh-thumb]', g);
      const counter = $('[data-wh-counter]', g);
      const total = $$('[data-wh-slide]', g).length;
      const go = (i) => {
        const idx = Math.max(0, Math.min(total - 1, i));
        track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
      };
      const current = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      const sync = () => {
        const i = current();
        thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
        if (counter) counter.textContent = (i + 1) + ' / ' + total;
        const active = thumbs[i];
        if (active && active.parentElement) {
          const p = active.parentElement;
          const left = active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2;
          p.scrollTo({ left, behavior: 'smooth' });
        }
      };
      let raf;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      thumbs.forEach((t, n) => t.addEventListener('click', () => go(n)));
      const prev = $('[data-wh-prev]', g), next = $('[data-wh-next]', g);
      if (prev) prev.addEventListener('click', () => go(current() - 1));
      if (next) next.addEventListener('click', () => go(current() + 1));
      sync();
    });
  }

  /* ---------- Bundle offers ---------- */
  function initOffers(root) {
    $$('[data-wh-offers]', root).forEach((wrap) => {
      if (wrap.dataset.whReady) return;
      wrap.dataset.whReady = '1';
      const qtyInput = document.getElementById(wrap.dataset.qtyInput);
      const priceLabel = document.querySelectorAll('[data-wh-atc-price="' + wrap.dataset.section + '"]');
      const cards = $$('[data-wh-offer-card]', wrap);
      const select = (card) => {
        cards.forEach((c) => {
          const on = c === card;
          c.classList.toggle('is-selected', on);
          const r = $('input', c);
          if (r) r.checked = on;
        });
        if (qtyInput) qtyInput.value = card.dataset.qty;
        priceLabel.forEach((el) => { el.textContent = formatINR(Number(card.dataset.total)); });
      };
      cards.forEach((c) => {
        c.addEventListener('click', () => select(c));
        const r = $('input', c);
        if (r) r.addEventListener('change', () => select(c));
      });
      const pre = cards.find((c) => c.classList.contains('is-selected')) || cards[0];
      if (pre) select(pre);
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky(root) {
    $$('[data-wh-sticky]', root).forEach((bar) => {
      if (bar.dataset.whReady) return;
      bar.dataset.whReady = '1';
      const target = document.getElementById(bar.dataset.target);
      if (!target) return;
      const footer = document.querySelector('.wh-footer, footer');
      let pastBuy = false, atFooter = false;
      const update = () => bar.classList.toggle('is-visible', pastBuy && !atFooter);
      new IntersectionObserver(([en]) => {
        pastBuy = !en.isIntersecting && en.boundingClientRect.top < 0;
        update();
      }).observe(target);
      if (footer) new IntersectionObserver(([en]) => { atFooter = en.isIntersecting; update(); }).observe(footer);
      $('[data-wh-sticky-btn]', bar).addEventListener('click', () => {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => target.click(), 450);
      });
    });
  }

  /* ---------- Horizontal sliders (ingredients) ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wh-slide-btn]');
    if (!btn) return;
    const track = document.getElementById(btn.dataset.track);
    if (!track) return;
    const card = track.firstElementChild;
    const step = card ? card.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
    track.scrollBy({ left: btn.dataset.whSlideBtn === 'prev' ? -step : step, behavior: 'smooth' });
  });

  /* ---------- Modals ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-wh-modal-open]');
    if (opener) {
      const m = document.getElementById(opener.dataset.whModalOpen);
      if (m) { m.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-wh-modal-close]')) {
      const m = e.target.closest('.wh-modal');
      if (m) { m.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.wh-modal.is-open').forEach((m) => m.classList.remove('is-open'));
    document.body.style.overflow = '';
  });

  /* ---------- Mobile drawer ---------- */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-wh-drawer-open]')) {
      const d = document.getElementById('WhDrawer');
      if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    } else if (e.target.closest('[data-wh-drawer-close]')) {
      const d = document.getElementById('WhDrawer');
      if (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
  });

  /* ---------- Scroll-to-buy CTAs ---------- */
  document.addEventListener('click', (e) => {
    const cta = e.target.closest('[data-wh-scroll-buy]');
    if (!cta) return;
    const buy = document.querySelector('[data-wh-buy-anchor]');
    if (!buy) return;
    e.preventDefault();
    buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  function initAll(root) {
    initCountdowns(root);
    initGalleries(root);
    initOffers(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();